import axios from "axios";
// import { Message } from 'element-ui'
import router from "../router";
import { MessageBox, Message } from "element-ui";
import store from "@/store";
import { getToken, removeToken, removeUserInfo } from "@/utils/auth";
import qs from "qs";
import { _isMobile } from "./index";
let flag = true;
let isMobile = _isMobile();
// create an axios instance
const service = axios.create({
  baseURL: process.env.BASE_API, // url = base url + request url
  // withCredentials: true, // send cookies when cross-domain requests
  timeout: 60000 // request timeout
});

service.interceptors.request.use(
  // config => {
  //   if (store.getters.token) {
  //     // config.headers['Token'] = getToken()
  //   }
  //   return config
  // },
  config => {
    // console.log(config);
    config.headers = {
      "content-type": "application/x-www-form-urlencoded"
    };
    config.url = config.url + "&key=" + (getToken() || "");
    if (config.method === "post") {
      const data = qs.parse(config.data);
      config.data = qs.stringify({
        ...data
      });
    } else if (config.method === "get") {
      const params = qs.parse(config.data);
      // config.params = qs.stringify({
      //   token: getToken(),
      //   ...params
      // })
      // params.token = getToken()
      config.params = params;
    }
    return config;
  },
  error => {
    // do something with request error
    console.log(error); // for debug
    return Promise.reject(error);
  }
);

// response interceptor
service.interceptors.response.use(
  response => {
    const { code } = response.data;
    if (code == 1000 || code == 1002 || code == 1003) {
      let msg = "";
      if (code == 1000) {
        msg = "帐号信息已过期，请重新登录";
      }
      if (code == 1002) {
        msg = "强制下线，帐号在其他地方登录";
      }
      if (code == 1003) {
        msg = "请先登录";
      }
      if (flag) {
        flag = false;
        store.dispatch("user/resetLoginStatus");
        MessageBox.alert(msg, "提示", {
          confirmButtonText: "确定",
          callback: action => {
            router.push(isMobile ? "/mobile/login" : "/login");
            setTimeout(() => {
              location.reload();
            }, 500);
          }
        });
      } else {
        Message({
          message: msg,
          type: "warning"
        });
        router.push(isMobile ? "/mobile/login" : "/login");
        setTimeout(() => {
          location.reload();
        }, 500);
        return;
      }
    }
    // 判断是否多处登陆
    // 判断是否多处登陆
    // if (res.status === 'ERR_USER_FINGER_NOT_MATCH') {
    //   localStorage.removeItem('enterprise_update_time')
    //   localStorage.removeItem('user_update_time')
    //   MessageBox.alert('您的账号已在别处登陆，请重新登录', '提示', {
    //     confirmButtonText: '确定',
    //     callback: action => {
    //       console.log(action)
    //       removeUserInfo()
    //       setTimeout(() => {
    //         router.push('/login')
    //         setTimeout(() => {
    //           location.reload()
    //         }, 500)
    //       }, 500)
    //     }
    //   })
    // } else if (res.status === 'ERR_TOKEN_EMPTY') {
    //   localStorage.removeItem('enterprise_update_time')
    //   localStorage.removeItem('user_update_time')
    //   MessageBox.alert('token失效请重新登录', '提示', {
    //     confirmButtonText: '确定',
    //     callback: action => {
    //       console.log(action)
    //       removeUserInfo()
    //       setTimeout(() => {
    //         router.push('/login')
    //         setTimeout(() => {
    //           location.reload()
    //         }, 500)
    //       }, 500)
    //     }
    //   })
    // } else if (res.status === 'ERR_USER_NO_EXIST') {
    //   localStorage.removeItem('enterprise_update_time')
    //   localStorage.removeItem('user_update_time')
    //   MessageBox.alert('token失效请重新登录', '提示', {
    //     confirmButtonText: '确定',
    //     callback: action => {
    //       console.log(action)
    //       removeUserInfo()
    //       setTimeout(() => {
    //         router.push('/login')
    //         setTimeout(() => {
    //           location.reload()
    //         }, 500)
    //       }, 500)
    //     }
    //   })
    // }
    // if (res.code !== 20000) {
    //   Message({
    //     message: res.message || 'Error',
    //     type: 'error',
    //     duration: 5 * 1000
    //   })

    //   // 50008: Illegal token; 50012: Other clients logged in; 50014: Token expired;
    //   if (res.code === 50008 || res.code === 50012 || res.code === 50014) {
    //     // to re-login
    //     MessageBox.confirm('You have been logged out, you can cancel to stay on this page, or log in again', 'Confirm logout', {
    //       confirmButtonText: 'Re-Login',
    //       cancelButtonText: 'Cancel',
    //       type: 'warning'
    //     }).then(() => {
    //       store.dispatch('user/resetToken').then(() => {
    //         location.reload()
    //       })
    //     })
    //   }
    //   return Promise.reject(new Error(res.message || 'Error'))
    // } else {
    //   return res
    // }
    return response.data;
  },
  error => {
    console.log("err" + error); // for debug
    // Message({
    //   message: error.message,
    //   type: 'error',
    //   duration: 5 * 1000
    // })
    return Promise.reject(error);
  }
);

export default service;



// WEBPACK FOOTER //
// ./src/utils/request.js